export default "__VITE_ASSET__BKisv6cR__"